export const FETCH_USER_RECORD_LIST_STARTED = 'FETCH/USER/RECORD/LIST/STARTED';
export const FETCH_USER_RECORD_LIST_SUCCESS = 'FETCH/USER/RECORD/LIST/SUCCESS';
export const FETCH_USER_RECORD_LIST_FAILURE = 'FETCH/USER/RECORD/LIST/FAILURE';

